import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

import Tippy from "@tippyjs/react";

const DropdownButton = ({
    buttonName,
    options,
    icon,
    disabled,
    className = "",
    menuClassNames = "w-56",
    optionsClassNames = "",
    controlled = false,
    open = false,
}) => {
    const renderOptions = () => {
        const renderButton = (option) => {
            return (
                <>
                    <button
                        onClick={option.callback}
                        disabled={option.disabled}
                        className={`default-orange-outline-btn export-options flex items-center w-full h-full p-2 ${optionsClassNames} ${
                            option.disabled ? "disabled" : ""
                        }`}
                    >
                        <div className="flex items-center gap-1">
                            {option.icon && (
                                <i className={`fas fa-${option.icon}`} />
                            )}

                            {option.displayName || option.label}
                        </div>
                    </button>
                    {option.horizontalLine && <hr className="mx-2 my-1" />}
                </>
            );
        };

        return (
            options &&
            options.map((option, index) => {
                return (
                    <span key={index} id={`dynamic-dropdown-option-${index}`}>
                        {option.tooltip ? (
                            <Tippy
                                content={option.tooltip}
                                placement="bottom"
                                animation="scale"
                            >
                                {renderButton(option, index)}
                            </Tippy>
                        ) : (
                            <Menu.Item>{renderButton(option, index)}</Menu.Item>
                        )}
                    </span>
                );
            })
        );
    };
    return (
        <>
            <Menu as="div" className="relative inline-block text-left">
                <>
                    <div id="dynamic-dropdown-button">
                        <Menu.Button
                            className={`default-orange-btn ${className} flex gap-2 items-center`}
                            disabled={disabled}
                        >
                            {icon && <i className={`${icon} fa-sm`} />}
                            {buttonName}
                            <i className="fas fa-chevron-down fa-sm ml-1" />
                        </Menu.Button>
                    </div>

                    {(!controlled || open) && (
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items
                                className={`origin-top-right absolute right-0 mt-2 ${menuClassNames} rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-20`}
                            >
                                {renderOptions()}
                            </Menu.Items>
                        </Transition>
                    )}
                </>
            </Menu>
        </>
    );
};

export default DropdownButton;
